var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarningOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1344,
    height: 420,
    viewBox: "0 0 1344 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.816 202.796L148.217 202.796",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1165.54 202.038L1036.55 276.514L1036.55 127.562L1165.54 202.038Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.05 128.428L1164.54 202.038L1037.05 275.648L1037.05 128.428Z",
    stroke: "#DBF1C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.665 202.038L23.6692 276.514L23.6692 127.562L152.665 202.038Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1692 128.428L151.665 202.038L24.1692 275.648L24.1692 128.428Z",
    stroke: "#B2D530"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1316.18 113.036L1187.18 187.512L1187.18 38.5605L1316.18 113.036Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.68 39.4265L1315.18 113.036L1187.68 186.646L1187.68 39.4265Z",
    stroke: "#DBF1C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1316.18 289.041L1187.18 363.517L1187.18 214.565L1316.18 289.041Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.68 215.431L1315.18 289.041L1187.68 362.651L1187.68 215.431Z",
    stroke: "#DBF1C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M893.465 202.039L1022.46 127.563L1022.46 276.515L893.465 202.039Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.96 275.649L894.465 202.039L1021.96 128.429L1021.96 275.649Z",
    stroke: "#DBF1C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044.1 113.036L1173.09 38.5602L1173.09 187.512L1044.1 113.036Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.59 186.646L1045.1 113.036L1172.59 39.4262L1172.59 186.646Z",
    stroke: "#DBF1C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044.1 289.041L1173.09 214.565L1173.09 363.517L1044.1 289.041Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.59 362.651L1045.1 289.041L1172.59 215.431L1172.59 362.651Z",
    stroke: "#DBF1C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1194.73 202.039L1323.73 127.563L1323.73 276.515L1194.73 202.039Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.23 275.649L1195.73 202.039L1323.23 128.429L1323.23 275.649Z",
    stroke: "#DBF1C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.165 109.845L704.174 156.038V248.426L624.165 294.619L544.155 248.426V156.038L624.165 109.845Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.655 156.327L624.165 110.422L703.674 156.327V248.137L624.165 294.042L544.655 248.137V156.327Z",
    stroke: "#53A626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.008 387.521L819.037 202.797",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.04 202.797L505.011 18.0737",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M864.716 202.796L819.036 202.796",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1188 11.2365L862.346 202.797",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.343 202.798L1188 394.358",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.5862 304H75.6102V287.2H72.5862V304ZM80.1069 304H83.0349L83.0109 291.64L93.9789 304.096H95.4669V287.2H92.5389L92.5629 298.096L82.9629 287.2H80.1069V304ZM99.0972 291.664C99.0972 294.352 100.897 295.6 103.561 296.704C105.961 297.712 106.897 298.36 106.897 299.56C106.897 300.856 105.841 301.6 104.209 301.6C102.361 301.6 100.177 300.424 98.5452 298.984L98.4972 299.032L99.0972 302.68C100.441 303.664 102.169 304.288 104.113 304.288C107.521 304.288 109.849 302.344 109.849 299.344C109.849 296.824 108.313 295.504 105.361 294.256C102.769 293.128 102.049 292.576 102.049 291.4C102.049 290.296 102.913 289.6 104.425 289.6C106.057 289.6 107.713 290.368 109.057 291.304H109.105V288.16C107.905 287.416 106.489 286.912 104.521 286.912C101.233 286.912 99.0972 288.808 99.0972 291.664ZM127.575 289.912V287.2H111.927V289.912H118.239V304H121.263V289.912H127.575ZM126.874 304H129.994L131.722 300.088H139.978L141.634 304H144.898L137.506 287.128H134.506L126.874 304ZM132.802 297.52L135.922 290.44L138.922 297.52H132.802ZM147.677 304H157.685V301.288H150.701V287.2H147.677V304ZM160.779 304H170.787V301.288H163.803V287.2H160.779V304ZM71.7222 325.664C71.7222 328.352 73.5222 329.6 76.1862 330.704C78.5862 331.712 79.5222 332.36 79.5222 333.56C79.5222 334.856 78.4662 335.6 76.8342 335.6C74.9862 335.6 72.8022 334.424 71.1702 332.984L71.1222 333.032L71.7222 336.68C73.0662 337.664 74.7942 338.288 76.7382 338.288C80.1462 338.288 82.4742 336.344 82.4742 333.344C82.4742 330.824 80.9382 329.504 77.9862 328.256C75.3942 327.128 74.6742 326.576 74.6742 325.4C74.6742 324.296 75.5382 323.6 77.0502 323.6C78.6822 323.6 80.3382 324.368 81.6822 325.304H81.7302V322.16C80.5302 321.416 79.1142 320.912 77.1462 320.912C73.8582 320.912 71.7222 322.808 71.7222 325.664ZM84.0067 338H87.1267L88.8547 334.088H97.1107L98.7667 338H102.031L94.6387 321.128H91.6387L84.0067 338ZM89.9347 331.52L93.0547 324.44L96.0547 331.52H89.9347ZM104.81 338H114.818V335.288H107.834V321.2H104.81V338ZM116.304 338H119.424L121.152 334.088H129.408L131.064 338H134.328L126.936 321.128H123.936L116.304 338ZM122.232 331.52L125.352 324.44L128.352 331.52H122.232ZM137.107 338H142.891C148.555 338 152.467 334.64 152.467 329.552C152.467 324.416 148.819 321.2 142.891 321.2H137.107V338ZM142.843 323.912C146.755 323.912 149.371 325.952 149.371 329.6C149.371 333.128 146.635 335.288 142.915 335.288H140.131V323.912H142.843Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.423 200.279H328.455L329.175 197.615H321.447V193.007H327.831V190.487H321.447V186.143H329.103L328.383 183.479H318.423V200.279ZM331.042 200.279H334.162L335.89 196.367H344.146L345.802 200.279H349.066L341.674 183.407H338.674L331.042 200.279ZM336.97 193.799L340.09 186.719L343.09 193.799H336.97ZM361.781 200.279H365.477L359.477 193.343C361.685 192.599 363.125 190.847 363.125 188.567C363.125 185.255 360.653 183.479 357.173 183.479H351.845V200.279H354.869V193.847H356.333L361.781 200.279ZM357.029 186.047C358.781 186.047 360.077 187.031 360.077 188.663C360.077 190.295 358.781 191.399 356.933 191.399H354.821V186.047H357.029ZM367.455 200.279H370.383L370.359 187.919L381.327 200.375H382.815V183.479H379.887L379.911 194.375L370.311 183.479H367.455V200.279ZM330.159 229.479C330.159 227.463 328.911 226.167 327.015 225.519C328.551 224.775 329.463 223.527 329.463 221.895C329.463 219.135 327.423 217.479 323.991 217.479H318.423V234.279H323.943C327.543 234.279 330.159 232.503 330.159 229.479ZM321.327 219.951H323.703C325.431 219.951 326.511 220.791 326.511 222.159C326.511 223.551 325.383 224.559 323.487 224.559H321.327V219.951ZM321.327 231.807V226.911H323.775C325.959 226.911 327.159 227.775 327.159 229.359C327.159 230.775 325.983 231.807 323.919 231.807H321.327ZM331.745 234.279H334.865L336.593 230.367H344.849L346.505 234.279H349.769L342.377 217.407H339.377L331.745 234.279ZM337.673 227.799L340.793 220.719L343.793 227.799H337.673ZM352.548 234.279H362.556V231.567H355.572V217.479H352.548V234.279ZM364.042 234.279H367.162L368.89 230.367H377.146L378.802 234.279H382.066L374.674 217.407H371.674L364.042 234.279ZM369.97 227.799L373.09 220.719L376.09 227.799H369.97ZM384.845 234.279H387.773L387.749 221.919L398.717 234.375H400.205V217.479H397.277L397.301 228.375L387.701 217.479H384.845V234.279ZM412.02 234.567C414.516 234.567 416.34 233.679 417.804 232.599L418.236 229.215L418.188 229.191C416.508 230.727 414.54 231.759 412.332 231.759C409.38 231.759 406.692 229.455 406.692 225.807C406.692 222.543 409.26 219.999 412.38 219.999C414.564 219.999 416.388 221.199 417.852 222.639H417.9V219.183C416.628 218.103 414.828 217.191 412.332 217.191C407.508 217.191 403.596 220.887 403.596 225.879C403.596 231.159 407.388 234.567 412.02 234.567ZM421.665 234.279H431.697L432.417 231.615H424.689V227.007H431.073V224.487H424.689V220.143H432.345L431.625 217.479H421.665V234.279Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.151 81.8623H829.847L823.847 74.9263C826.055 74.1823 827.495 72.4303 827.495 70.1503C827.495 66.8383 825.023 65.0623 821.543 65.0623H816.215V81.8623H819.239V75.4303H820.703L826.151 81.8623ZM821.399 67.6303C823.151 67.6303 824.447 68.6143 824.447 70.2463C824.447 71.8783 823.151 72.9823 821.303 72.9823H819.191V67.6303H821.399ZM831.825 81.8623H841.857L842.577 79.1983H834.849V74.5903H841.233V72.0703H834.849V67.7263H842.505L841.785 65.0623H831.825V81.8623ZM846.051 81.8623H851.835C857.499 81.8623 861.411 78.5023 861.411 73.4143C861.411 68.2783 857.763 65.0623 851.835 65.0623H846.051V81.8623ZM851.787 67.7743C855.699 67.7743 858.315 69.8143 858.315 73.4623C858.315 76.9903 855.579 79.1503 851.859 79.1503H849.075V67.7743H851.787ZM864.801 81.8623H874.833L875.553 79.1983H867.825V74.5903H874.209V72.0703H867.825V67.7263H875.481L874.761 65.0623H864.801V81.8623ZM879.028 81.8623H889.06L889.78 79.1983H882.052V74.5903H888.436V72.0703H882.052V67.7263H889.708L888.988 65.0623H879.028V81.8623ZM897.622 65.0623H893.254V81.8623H896.134V68.3503L903.214 82.1263H903.574L910.654 68.2303V81.8623H913.606V65.0623H909.19L903.43 76.6783L897.622 65.0623ZM826.151 115.862H829.847L823.847 108.926C826.055 108.182 827.495 106.43 827.495 104.15C827.495 100.838 825.023 99.0623 821.543 99.0623H816.215V115.862H819.239V109.43H820.703L826.151 115.862ZM821.399 101.63C823.151 101.63 824.447 102.614 824.447 104.246C824.447 105.878 823.151 106.982 821.303 106.982H819.191V101.63H821.399ZM831.825 115.862H841.857L842.577 113.198H834.849V108.59H841.233V106.07H834.849V101.726H842.505L841.785 99.0623H831.825V115.862ZM871.131 99.0623H867.939L863.763 111.926L858.147 98.8463H857.739L851.907 111.95L847.923 99.0623H844.635L850.251 115.958H853.155L857.835 105.182L862.371 115.958H865.275L871.131 99.0623ZM870.857 115.862H873.977L875.705 111.95H883.961L885.617 115.862H888.881L881.489 98.9903H878.489L870.857 115.862ZM876.785 109.382L879.905 102.302L882.905 109.382H876.785ZM901.597 115.862H905.293L899.293 108.926C901.501 108.182 902.941 106.43 902.941 104.15C902.941 100.838 900.469 99.0623 896.989 99.0623H891.661V115.862H894.685V109.43H896.149L901.597 115.862ZM896.845 101.63C898.597 101.63 899.893 102.614 899.893 104.246C899.893 105.878 898.597 106.982 896.749 106.982H894.637V101.63H896.845ZM907.27 115.862H913.054C918.718 115.862 922.63 112.502 922.63 107.414C922.63 102.278 918.982 99.0623 913.054 99.0623H907.27V115.862ZM913.006 101.774C916.918 101.774 919.534 103.814 919.534 107.462C919.534 110.99 916.798 113.15 913.078 113.15H910.294V101.774H913.006ZM925.276 103.526C925.276 106.214 927.076 107.462 929.74 108.566C932.14 109.574 933.076 110.222 933.076 111.422C933.076 112.718 932.02 113.462 930.388 113.462C928.54 113.462 926.356 112.286 924.724 110.846L924.676 110.894L925.276 114.542C926.62 115.526 928.348 116.15 930.292 116.15C933.7 116.15 936.028 114.206 936.028 111.206C936.028 108.686 934.492 107.366 931.54 106.118C928.948 104.99 928.228 104.438 928.228 103.262C928.228 102.158 929.092 101.462 930.604 101.462C932.236 101.462 933.892 102.23 935.236 103.166H935.284V100.022C934.084 99.2783 932.668 98.7743 930.7 98.7743C927.412 98.7743 925.276 100.67 925.276 103.526Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.085 232.713H628.923C629.687 232.713 630.435 232.5 631.084 232.099C631.734 231.698 632.258 231.123 632.6 230.441C632.941 229.758 633.086 228.994 633.017 228.233C632.948 227.473 632.67 226.747 632.212 226.136L629.24 222.174V202.36C629.232 197.948 627.785 193.66 625.117 190.146C622.449 186.632 618.707 184.086 614.46 182.893L618.995 173.837C619.133 173.561 619.165 173.244 619.086 172.946C619.007 172.649 618.822 172.39 618.565 172.219L617.301 171.374C616.346 170.74 615.241 170.369 614.098 170.298C612.954 170.227 611.812 170.458 610.786 170.969C610.235 171.244 609.627 171.387 609.011 171.387C608.395 171.387 607.787 171.244 607.236 170.969C606.211 170.459 605.069 170.227 603.925 170.298C602.782 170.369 601.677 170.74 600.723 171.374L599.458 172.219C599.202 172.39 599.016 172.649 598.937 172.946C598.858 173.244 598.89 173.561 599.028 173.837L603.557 182.893C599.308 184.084 595.564 186.63 592.895 190.144C590.225 193.658 588.777 197.947 588.769 202.36V222.174L585.797 226.136C585.339 226.747 585.06 227.473 584.991 228.233C584.923 228.994 585.067 229.758 585.409 230.441C585.75 231.123 586.275 231.698 586.924 232.099C587.573 232.5 588.322 232.713 589.085 232.713ZM601.781 173.704L602.119 173.48C602.701 173.092 603.376 172.865 604.074 172.82C604.772 172.776 605.47 172.916 606.097 173.227C607 173.677 607.996 173.911 609.005 173.911C610.015 173.911 611.011 173.677 611.914 173.227C612.541 172.915 613.239 172.774 613.938 172.818C614.636 172.863 615.311 173.091 615.893 173.48L616.231 173.704L611.9 182.356C610.942 182.209 609.974 182.132 609.004 182.124C608.034 182.132 607.067 182.209 606.108 182.356L601.781 173.704ZM587.82 227.654L591.045 223.354C591.209 223.135 591.298 222.869 591.298 222.595V202.36C591.298 197.664 593.164 193.16 596.484 189.84C599.805 186.519 604.308 184.654 609.004 184.654C613.7 184.654 618.204 186.519 621.524 189.84C624.845 193.16 626.71 197.664 626.71 202.36V222.595C626.71 222.869 626.799 223.135 626.963 223.354L630.188 227.654C630.364 227.889 630.471 228.168 630.498 228.46C630.524 228.753 630.469 229.047 630.337 229.309C630.206 229.572 630.004 229.793 629.754 229.947C629.505 230.102 629.217 230.183 628.923 230.183H589.085C588.791 230.183 588.504 230.102 588.254 229.947C588.004 229.793 587.802 229.572 587.671 229.309C587.54 229.047 587.484 228.753 587.51 228.46C587.537 228.168 587.644 227.889 587.82 227.654Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.592 199.83H655.798V193.507C655.798 193.171 655.665 192.85 655.428 192.613C655.19 192.375 654.869 192.242 654.533 192.242H651.554C653.388 190.765 654.72 188.755 655.364 186.489C656.008 184.223 655.934 181.813 655.151 179.592C654.367 177.37 652.914 175.446 650.992 174.085C649.069 172.724 646.771 171.994 644.416 171.994C642.06 171.994 639.762 172.724 637.84 174.085C635.917 175.446 634.464 177.37 633.681 179.592C632.898 181.813 632.823 184.223 633.467 186.489C634.111 188.755 635.443 190.765 637.278 192.242H634.298C633.962 192.242 633.641 192.375 633.404 192.613C633.166 192.85 633.033 193.171 633.033 193.507V201.095C633.033 201.431 633.166 201.752 633.404 201.989C633.641 202.227 633.962 202.36 634.298 202.36H638.092V207.419H634.298C633.962 207.419 633.641 207.552 633.404 207.789C633.166 208.026 633.033 208.348 633.033 208.683V216.272C633.033 216.607 633.166 216.929 633.404 217.166C633.641 217.403 633.962 217.536 634.298 217.536H638.092V231.448C638.092 231.784 638.225 232.105 638.462 232.342C638.7 232.58 639.021 232.713 639.357 232.713H659.592C659.928 232.713 660.249 232.58 660.486 232.342C660.724 232.105 660.857 231.784 660.857 231.448V216.272C660.857 215.936 660.724 215.615 660.486 215.377C660.249 215.14 659.928 215.007 659.592 215.007H655.798V209.948H659.592C659.928 209.948 660.249 209.815 660.486 209.578C660.724 209.341 660.857 209.019 660.857 208.683V201.095C660.857 200.76 660.724 200.438 660.486 200.201C660.249 199.964 659.928 199.83 659.592 199.83ZM635.563 183.389C635.563 181.638 636.082 179.927 637.055 178.471C638.027 177.015 639.41 175.88 641.028 175.21C642.645 174.54 644.425 174.365 646.143 174.706C647.86 175.048 649.438 175.891 650.676 177.129C651.914 178.367 652.757 179.945 653.098 181.662C653.44 183.379 653.265 185.159 652.595 186.777C651.925 188.395 650.79 189.777 649.334 190.75C647.878 191.723 646.167 192.242 644.416 192.242C642.068 192.239 639.818 191.306 638.159 189.646C636.499 187.987 635.565 185.736 635.563 183.389ZM635.563 194.772H653.269V199.83H650.739V197.301H648.21V199.83H645.68V197.301H643.151V199.83H640.621V197.301H638.092V199.83H635.563V194.772ZM658.327 230.183H655.798V227.654H653.269V230.183H650.739V227.654H648.21V230.183H645.68V227.654H643.151V230.183H640.621V225.125H658.327V230.183ZM658.327 222.595H655.798V220.066H653.269V222.595H650.739V220.066H648.21V222.595H645.68V220.066H643.151V222.595H640.621V217.536H658.327V222.595ZM653.269 215.007H650.739V212.478H648.21V215.007H645.68V212.478H643.151V215.007H640.621V212.478H638.092V215.007H635.563V209.948H653.269V215.007ZM658.327 207.419H655.798V204.889H653.269V207.419H650.739V204.889H648.21V207.419H645.68V204.889H643.151V207.419H640.621V202.36H658.327V207.419Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.415 177.065C642.739 177.067 641.132 177.734 639.946 178.92C638.761 180.105 638.094 181.712 638.092 183.389H640.621C640.621 182.383 641.021 181.418 641.732 180.706C642.444 179.995 643.409 179.595 644.415 179.595V177.065Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.209 183.389C648.209 184.395 647.809 185.36 647.098 186.072C646.386 186.784 645.421 187.183 644.415 187.183V189.713C646.092 189.711 647.699 189.044 648.884 187.858C650.07 186.673 650.737 185.066 650.739 183.389H648.209Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.497 216.272H607.74V218.801H610.269V216.272H610.512C611.685 216.269 612.817 215.838 613.695 215.06C614.573 214.281 615.137 213.209 615.281 212.044C615.424 210.88 615.137 209.703 614.475 208.735C613.812 207.766 612.818 207.074 611.68 206.786L606.943 205.602C606.399 205.469 605.923 205.141 605.605 204.68C605.287 204.22 605.149 203.658 605.218 203.103C605.286 202.547 605.556 202.036 605.976 201.666C606.396 201.296 606.937 201.093 607.497 201.095H610.512C611.118 201.096 611.699 201.337 612.128 201.765C612.557 202.194 612.798 202.775 612.798 203.382V203.624H615.328V203.382C615.326 202.105 614.819 200.881 613.916 199.978C613.013 199.075 611.789 198.567 610.512 198.566H610.269V196.036H607.74V198.566H607.497C606.323 198.568 605.191 198.999 604.313 199.778C603.435 200.556 602.871 201.628 602.728 202.793C602.584 203.957 602.871 205.134 603.534 206.102C604.197 207.071 605.19 207.763 606.328 208.051L611.066 209.235C611.609 209.368 612.085 209.696 612.403 210.157C612.721 210.617 612.859 211.179 612.791 211.734C612.723 212.29 612.453 212.801 612.033 213.171C611.613 213.541 611.072 213.744 610.512 213.742H607.497C606.89 213.741 606.309 213.5 605.881 213.072C605.452 212.643 605.211 212.062 605.21 211.455V211.213H602.681V211.455C602.682 212.732 603.19 213.957 604.093 214.859C604.996 215.762 606.22 216.27 607.497 216.272Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.956 162.945C627.906 162.65 627.754 162.383 627.525 162.19C627.297 161.997 627.008 161.891 626.709 161.891C626.41 161.891 626.121 161.997 625.893 162.19C625.664 162.383 625.512 162.65 625.462 162.945C625.294 163.95 624.817 164.878 624.096 165.599C623.375 166.32 622.447 166.798 621.442 166.965C621.147 167.015 620.879 167.168 620.686 167.396C620.494 167.624 620.388 167.914 620.388 168.212C620.388 168.511 620.494 168.801 620.686 169.029C620.879 169.257 621.147 169.41 621.442 169.459C622.447 169.627 623.375 170.105 624.096 170.826C624.817 171.546 625.294 172.474 625.462 173.48C625.512 173.775 625.664 174.042 625.893 174.235C626.121 174.428 626.41 174.534 626.709 174.534C627.008 174.534 627.297 174.428 627.525 174.235C627.754 174.042 627.906 173.775 627.956 173.48C628.124 172.474 628.601 171.546 629.322 170.826C630.043 170.105 630.971 169.627 631.977 169.459C632.271 169.41 632.539 169.257 632.732 169.029C632.925 168.801 633.03 168.511 633.03 168.212C633.03 167.914 632.925 167.624 632.732 167.396C632.539 167.168 632.271 167.015 631.977 166.965C630.971 166.798 630.043 166.32 629.322 165.599C628.601 164.878 628.124 163.95 627.956 162.945ZM626.709 170.018C626.216 169.317 625.605 168.706 624.903 168.212C625.605 167.719 626.216 167.108 626.709 166.406C627.202 167.108 627.813 167.719 628.515 168.212C627.813 168.706 627.202 169.317 626.709 170.018Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.32 190.297C1054.59 190.297 1049.08 195.532 1048.56 202.182L1055.42 205.046C1056 204.644 1056.7 204.411 1057.46 204.411C1057.53 204.411 1057.6 204.413 1057.66 204.418L1060.71 199.952V199.888C1060.71 197.2 1062.88 195.016 1065.54 195.016C1068.21 195.016 1070.37 197.202 1070.37 199.888C1070.37 202.576 1068.2 204.763 1065.54 204.763C1065.51 204.763 1065.47 204.763 1065.43 204.76L1061.08 207.895C1061.08 207.952 1061.09 208.011 1061.09 208.068C1061.09 210.086 1059.46 211.727 1057.46 211.727C1055.71 211.727 1054.24 210.464 1053.91 208.789L1049 206.743C1050.52 212.167 1055.46 216.145 1061.32 216.145C1068.39 216.145 1074.12 210.358 1074.12 203.222C1074.13 196.084 1068.39 190.297 1061.32 190.297ZM1056.58 209.905L1055.01 209.248C1055.29 209.835 1055.77 210.325 1056.41 210.593C1057.79 211.176 1059.39 210.514 1059.97 209.116C1060.24 208.44 1060.25 207.695 1059.97 207.015C1059.69 206.336 1059.17 205.809 1058.5 205.525C1057.84 205.246 1057.12 205.257 1056.5 205.495L1058.12 206.174C1059.14 206.602 1059.62 207.787 1059.2 208.815C1058.78 209.848 1057.6 210.334 1056.58 209.905ZM1068.76 199.89C1068.76 198.099 1067.32 196.642 1065.55 196.642C1063.77 196.642 1062.33 198.099 1062.33 199.89C1062.33 201.681 1063.77 203.136 1065.55 203.136C1067.32 203.136 1068.76 201.679 1068.76 199.89ZM1063.13 199.884C1063.13 198.536 1064.22 197.444 1065.55 197.444C1066.89 197.444 1067.97 198.536 1067.97 199.884C1067.97 201.231 1066.88 202.323 1065.55 202.323C1064.22 202.323 1063.13 201.231 1063.13 199.884Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.78 207.66H1126.6V202.002L1124.45 207.66H1123.14L1121 202.002V207.66H1118.69V197.937H1121.41L1123.8 204.545L1126.19 197.937H1128.78V207.66Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.95 198.066H1111.28L1107.74 208.02H1109.8L1110.39 206.396H1113.63L1114.22 208.02H1116.49L1112.95 198.066ZM1110.98 204.771L1112.16 201.235L1113.34 204.771H1110.98Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.81 207.66H1099.33V197.937H1105.81V199.616H1101.39V201.915H1105.22V203.594H1101.39V205.98H1105.81V207.66Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.64 199.616H1094.28V207.66H1092.22V199.616H1089.57V197.937H1096.64V199.616Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.72 204.8C1087.72 206.804 1085.95 207.716 1084.18 207.745C1082.41 207.745 1081.24 207.332 1080.65 206.448L1081.82 205.24C1082.41 205.769 1083 206.064 1084.18 206.064C1085.36 206.064 1085.95 205.651 1085.95 204.855C1085.95 204.119 1085.36 203.793 1084.77 203.677L1083.59 203.53C1081.82 203.294 1080.94 202.38 1080.94 200.789C1080.94 199.906 1081.23 199.198 1081.82 198.637C1082.41 198.108 1083.3 197.842 1084.18 197.842C1085.65 197.842 1086.54 198.224 1087.42 198.96L1086.24 200.169C1085.65 199.727 1085.07 199.492 1084.18 199.492C1083.3 199.552 1082.71 199.875 1082.71 200.73C1082.71 201.407 1083.3 201.732 1083.89 201.791L1085.07 201.967C1086.54 202.149 1087.72 203.152 1087.72 204.8Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.15 288.969C1236.12 291.762 1238.7 293.321 1240.64 294.248C1242.64 295.199 1243.31 295.808 1243.31 296.659C1243.29 297.961 1241.71 298.536 1240.23 298.558C1237.66 298.597 1236.16 297.877 1234.97 297.333L1234.04 301.583C1235.23 302.122 1237.45 302.592 1239.74 302.612C1245.13 302.612 1248.66 300.011 1248.68 295.977C1248.7 290.857 1241.43 290.575 1241.48 288.286C1241.5 287.592 1242.18 286.852 1243.66 286.663C1244.4 286.568 1246.42 286.495 1248.72 287.531L1249.62 283.419C1248.39 282.98 1246.8 282.558 1244.82 282.558C1239.75 282.558 1236.18 285.195 1236.15 288.969ZM1258.29 282.912C1257.31 282.912 1256.48 283.473 1256.11 284.334L1248.41 302.31H1253.79L1254.87 299.414H1261.45L1262.07 302.31H1266.82L1262.67 282.912H1258.29ZM1259.05 288.152L1260.6 295.436H1256.34L1259.05 288.152ZM1229.62 282.912L1225.38 302.31H1230.51L1234.75 282.912H1229.62ZM1222.03 282.912L1216.69 296.115L1214.53 284.889C1214.28 283.635 1213.28 282.912 1212.16 282.912H1203.43L1203.31 283.475C1205.1 283.856 1207.14 284.468 1208.37 285.125C1209.13 285.527 1209.34 285.877 1209.59 286.83L1213.68 302.31H1219.11L1227.42 282.912H1222.03Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.06 124.633C1127.78 127.799 1121.59 129.491 1116.26 129.491C1108.78 129.491 1102.05 126.71 1096.95 122.084C1096.55 121.72 1096.91 121.225 1097.39 121.509C1102.89 124.724 1109.68 126.659 1116.7 126.659C1121.44 126.659 1126.65 125.674 1131.43 123.63C1132.16 123.32 1132.76 124.104 1132.06 124.633Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.83 122.589C1133.29 121.888 1130.22 122.257 1128.85 122.421C1128.43 122.471 1128.36 122.105 1128.74 121.841C1131.18 120.113 1135.19 120.612 1135.66 121.191C1136.13 121.774 1135.54 125.814 1133.24 127.741C1132.89 128.037 1132.55 127.879 1132.71 127.486C1133.22 126.193 1134.38 123.294 1133.83 122.589Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.94 109.639V107.96C1128.94 107.704 1129.13 107.534 1129.36 107.534H1136.84C1137.08 107.534 1137.28 107.708 1137.28 107.96V109.398C1137.27 109.639 1137.07 109.955 1136.71 110.454L1132.84 116.019C1134.28 115.984 1135.8 116.199 1137.1 116.938C1137.4 117.107 1137.48 117.35 1137.5 117.593V119.386C1137.5 119.631 1137.23 119.917 1136.95 119.769C1134.65 118.555 1131.59 118.423 1129.05 119.781C1128.79 119.923 1128.52 119.639 1128.52 119.394V117.692C1128.52 117.419 1128.52 116.953 1128.79 116.537L1133.28 110.06H1129.37C1129.13 110.06 1128.94 109.89 1128.94 109.639Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.65 120.123H1099.38C1099.16 120.107 1098.99 119.943 1098.97 119.734V107.988C1098.97 107.753 1099.17 107.566 1099.41 107.566H1101.53C1101.75 107.577 1101.93 107.747 1101.94 107.96V109.495H1101.99C1102.54 108.01 1103.58 107.319 1104.98 107.319C1106.41 107.319 1107.3 108.012 1107.94 109.495C1108.49 108.012 1109.74 107.319 1111.08 107.319C1112.03 107.319 1113.08 107.714 1113.71 108.604C1114.43 109.592 1114.29 111.027 1114.29 112.287L1114.28 119.7C1114.28 119.935 1114.09 120.125 1113.84 120.125H1111.57C1111.34 120.109 1111.16 119.925 1111.16 119.7V113.472C1111.16 112.976 1111.21 111.74 1111.1 111.27C1110.93 110.482 1110.42 110.259 1109.76 110.259C1109.21 110.259 1108.63 110.63 1108.4 111.221C1108.17 111.813 1108.19 112.806 1108.19 113.472V119.698C1108.19 119.933 1107.99 120.123 1107.75 120.123H1105.48C1105.25 120.107 1105.07 119.923 1105.07 119.698L1105.07 113.472C1105.07 112.161 1105.28 110.235 1103.66 110.235C1102.03 110.235 1102.09 112.115 1102.09 113.472V119.698C1102.09 119.933 1101.9 120.123 1101.65 120.123Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.72 107.319C1147.09 107.319 1148.92 110.235 1148.92 113.944C1148.92 117.526 1146.9 120.368 1143.72 120.368C1140.4 120.368 1138.59 117.453 1138.59 113.818C1138.59 110.162 1140.42 107.319 1143.72 107.319ZM1143.74 109.716C1142.06 109.716 1141.95 112.013 1141.95 113.446C1141.95 114.882 1141.93 117.945 1143.72 117.945C1145.48 117.945 1145.56 115.474 1145.56 113.966C1145.56 112.976 1145.52 111.791 1145.22 110.851C1144.97 110.036 1144.46 109.716 1143.74 109.716Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.3 120.123H1151.03C1150.81 120.107 1150.63 119.923 1150.63 119.698L1150.62 107.949C1150.64 107.735 1150.83 107.566 1151.06 107.566H1153.17C1153.37 107.577 1153.53 107.71 1153.58 107.895V109.692H1153.62C1154.26 108.085 1155.15 107.319 1156.72 107.319C1157.74 107.319 1158.74 107.69 1159.38 108.703C1159.97 109.643 1159.97 111.223 1159.97 112.36V119.754C1159.94 119.961 1159.76 120.125 1159.53 120.125H1157.25C1157.04 120.109 1156.87 119.955 1156.85 119.754V113.373C1156.85 112.088 1156.99 110.208 1155.42 110.208C1154.87 110.208 1154.36 110.581 1154.11 111.148C1153.79 111.865 1153.74 112.581 1153.74 113.373V119.698C1153.74 119.933 1153.54 120.123 1153.3 120.123Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.03 117.97C1126.61 117.39 1126.17 116.92 1126.17 115.849V112.283C1126.17 110.774 1126.28 109.386 1125.17 108.347C1124.3 107.502 1122.85 107.206 1121.74 107.206C1119.58 107.206 1117.16 108.016 1116.65 110.709C1116.6 110.995 1116.81 111.146 1116.99 111.189L1119.2 111.428C1119.41 111.418 1119.56 111.215 1119.6 111.009C1119.78 110.081 1120.56 109.635 1121.42 109.635C1121.89 109.635 1122.42 109.809 1122.7 110.231C1123.02 110.701 1122.98 111.345 1122.98 111.888V112.184C1121.66 112.336 1119.93 112.431 1118.7 112.978C1117.27 113.596 1116.27 114.86 1116.27 116.718C1116.27 119.096 1117.76 120.283 1119.68 120.283C1121.29 120.283 1122.18 119.9 1123.43 118.62C1123.84 119.222 1123.98 119.516 1124.73 120.146C1124.9 120.235 1125.12 120.227 1125.27 120.091L1125.28 120.097C1125.73 119.692 1126.56 118.967 1127.02 118.578C1127.21 118.424 1127.17 118.176 1127.03 117.97ZM1122.55 116.941C1122.19 117.585 1121.61 117.98 1120.98 117.98C1120.1 117.98 1119.59 117.311 1119.59 116.323C1119.59 114.372 1121.33 114.017 1122.98 114.017V114.514C1122.98 115.405 1123 116.148 1122.55 116.941Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.19 117.97C1096.78 117.39 1096.34 116.92 1096.34 115.849V112.283C1096.34 110.774 1096.44 109.386 1095.34 108.347C1094.46 107.502 1093.01 107.206 1091.91 107.206C1089.74 107.206 1087.33 108.016 1086.82 110.709C1086.77 110.995 1086.97 111.146 1087.16 111.189L1089.36 111.428C1089.57 111.418 1089.72 111.215 1089.76 111.009C1089.95 110.081 1090.72 109.635 1091.59 109.635C1092.06 109.635 1092.59 109.809 1092.87 110.231C1093.18 110.701 1093.14 111.345 1093.14 111.888V112.184C1091.82 112.336 1090.1 112.431 1088.86 112.978C1087.44 113.596 1086.44 114.86 1086.44 116.718C1086.44 119.096 1087.93 120.283 1089.84 120.283C1091.46 120.283 1092.35 119.9 1093.59 118.62C1094.01 119.222 1094.14 119.516 1094.9 120.146C1095.07 120.235 1095.29 120.227 1095.44 120.091L1095.44 120.097C1095.9 119.692 1096.73 118.967 1097.19 118.578C1097.37 118.424 1097.34 118.176 1097.19 117.97ZM1092.72 116.941C1092.35 117.585 1091.78 117.98 1091.14 117.98C1090.27 117.98 1089.76 117.311 1089.76 116.323C1089.76 114.372 1091.5 114.017 1093.14 114.017V114.514C1093.14 115.405 1093.17 116.148 1092.72 116.941Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.409 201.058C941.779 201.058 941.281 201.591 941.281 202.256C941.281 202.92 941.79 203.454 942.409 203.454C943.039 203.454 943.537 202.92 943.537 202.256C943.537 201.591 943.028 201.058 942.409 201.058ZM938.374 201.058C937.744 201.058 937.246 201.591 937.246 202.256C937.246 202.92 937.755 203.454 938.374 203.454C939.004 203.454 939.501 202.92 939.501 202.256C939.512 201.591 939.004 201.058 938.374 201.058Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.781 191.996H932.967C931.717 191.996 930.7 192.998 930.7 194.228V208.823C930.7 210.054 931.717 211.056 932.967 211.056H945.504L944.918 209.063L946.333 210.348L947.67 211.557L950.058 213.593V194.228C950.047 192.998 949.03 191.996 947.781 191.996ZM943.514 206.1C943.514 206.1 943.116 205.632 942.784 205.229C944.232 204.826 944.785 203.944 944.785 203.944C944.332 204.238 943.901 204.445 943.514 204.586C942.961 204.815 942.43 204.957 941.911 205.055C940.849 205.251 939.876 205.196 939.047 205.044C938.417 204.924 937.875 204.76 937.422 204.575C937.168 204.477 936.891 204.357 936.615 204.205C936.582 204.183 936.549 204.172 936.515 204.151C936.493 204.14 936.482 204.129 936.471 204.129C936.272 204.02 936.162 203.944 936.162 203.944C936.162 203.944 936.692 204.804 938.096 205.218C937.765 205.632 937.356 206.111 937.356 206.111C934.912 206.035 933.984 204.466 933.984 204.466C933.984 200.992 935.576 198.171 935.576 198.171C937.168 197.006 938.671 197.038 938.671 197.038L938.782 197.169C936.792 197.725 935.885 198.585 935.885 198.585C935.885 198.585 936.128 198.454 936.538 198.28C937.72 197.768 938.66 197.637 939.047 197.594C939.113 197.583 939.169 197.572 939.235 197.572C939.909 197.485 940.672 197.463 941.468 197.55C942.519 197.67 943.646 197.975 944.796 198.585C944.796 198.585 943.923 197.768 942.043 197.213L942.198 197.038C942.198 197.038 943.713 197.006 945.294 198.171C945.294 198.171 946.886 200.992 946.886 204.466C946.886 204.455 945.957 206.024 943.514 206.1ZM960.207 196.657H956.537V200.72L958.98 202.887V198.944H960.285C961.114 198.944 961.523 199.336 961.523 199.968V202.985C961.523 203.617 961.136 204.042 960.285 204.042H956.526V206.34H960.196C962.164 206.351 964.011 205.381 964.011 203.159V199.914C964.022 197.648 962.175 196.657 960.207 196.657ZM979.444 203.159V199.827C979.444 198.629 981.633 198.356 982.296 199.554L984.32 198.748C983.524 197.027 982.075 196.526 980.87 196.526C978.902 196.526 976.957 197.648 976.957 199.827V203.159C976.957 205.359 978.902 206.46 980.826 206.46C982.064 206.46 983.546 205.861 984.364 204.292L982.197 203.312C981.666 204.652 979.444 204.325 979.444 203.159ZM972.755 200.284C971.993 200.121 971.484 199.848 971.451 199.38C971.495 198.258 973.253 198.215 974.281 199.293L975.906 198.062C974.889 196.842 973.739 196.516 972.556 196.516C970.754 196.516 969.008 197.518 969.008 199.413C969.008 201.253 970.445 202.245 972.026 202.484C972.833 202.593 973.728 202.909 973.706 203.453C973.64 204.488 971.473 204.434 970.489 203.257L968.919 204.706C969.837 205.871 971.086 206.46 972.258 206.46C974.06 206.46 976.061 205.436 976.138 203.562C976.249 201.199 974.502 200.6 972.755 200.284ZM965.348 206.329H967.825V196.657H965.348V206.329ZM1007.11 196.657H1003.43V200.72L1005.88 202.887V198.944H1007.18C1008.01 198.944 1008.42 199.336 1008.42 199.968V202.985C1008.42 203.617 1008.03 204.042 1007.18 204.042H1003.42V206.34H1007.11C1009.07 206.351 1010.92 205.381 1010.92 203.159V199.914C1010.92 197.648 1009.07 196.657 1007.11 196.657ZM989.096 196.526C987.061 196.526 985.038 197.616 985.038 199.848V203.149C985.038 205.359 987.072 206.47 989.118 206.47C991.152 206.47 993.175 205.359 993.175 203.149V199.848C993.175 197.627 991.13 196.526 989.096 196.526ZM990.688 203.149C990.688 203.846 989.892 204.205 989.107 204.205C988.311 204.205 987.515 203.867 987.515 203.149V199.848C987.515 199.14 988.289 198.759 989.062 198.759C989.869 198.759 990.688 199.097 990.688 199.848V203.149ZM1002.06 199.848C1002.01 197.583 1000.44 196.668 998.415 196.668H994.491V206.34H997V203.268H997.443L999.72 206.34H1002.82L1000.14 203.018C1001.32 202.648 1002.06 201.635 1002.06 199.848ZM998.46 201.155H997V198.944H998.46C1000.02 198.944 1000.02 201.155 998.46 201.155Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.14 199.635C1240.14 198.634 1240.79 197.918 1241.93 197.918C1242.79 197.918 1243.32 198.316 1243.32 198.999C1243.32 199.889 1242.78 200.43 1240.28 200.732C1240.19 200.382 1240.14 200.016 1240.14 199.635ZM1238.56 205.849C1237.04 205.849 1236.26 205.388 1236.26 204.482C1236.29 203.608 1236.85 203.036 1238.91 202.718C1239.33 203.433 1239.85 204.101 1240.42 204.673C1240.68 204.927 1240.93 205.166 1241.17 205.388C1240.31 205.675 1239.44 205.849 1238.56 205.849ZM1247.21 207.852C1248.28 207.852 1249.12 207.582 1249.58 207.137V204.816C1249.04 205.373 1248.39 205.786 1247.1 205.786C1246.38 205.786 1245.73 205.675 1245.08 205.452C1247.05 204.037 1248.85 202.035 1249.99 199.396H1247.5C1246.7 201.351 1245.11 203.179 1243.21 204.387C1242.82 204.085 1242.44 203.751 1242.04 203.354C1241.71 203.02 1241.41 202.686 1241.17 202.369C1244.32 201.781 1245.45 200.779 1245.45 199.015C1245.45 197.362 1244.19 196.027 1242.04 196.027C1239.77 196.027 1238.01 197.426 1238.01 199.794C1238.01 200.191 1238.07 200.62 1238.18 201.033C1235.05 201.526 1233.86 202.766 1233.86 204.769C1233.86 206.787 1235.62 207.884 1238.42 207.884C1239.71 207.884 1241.3 207.502 1242.89 206.739C1244.27 207.629 1245.49 207.852 1247.21 207.852ZM1257.97 204.737H1258.16L1262.49 199.953V207.598H1265.07V196.265H1262.75L1258.14 201.415L1253.74 196.265H1251.24V207.598H1253.82V200L1257.97 204.737ZM1273.83 207.916C1277.8 207.916 1280.62 206.008 1280.62 202.067V201.955C1280.62 198.109 1277.73 195.979 1273.82 195.979C1269.91 195.979 1267.06 198.173 1267.06 201.971V202.051C1267.06 206.12 1269.76 207.916 1273.83 207.916ZM1273.82 205.5C1271.3 205.5 1269.81 204.403 1269.81 202.035V202.019C1269.81 199.444 1271.3 198.379 1273.83 198.379C1276.33 198.379 1277.87 199.365 1277.87 202.035V202.051C1277.87 204.61 1276.33 205.5 1273.82 205.5ZM1288.54 198.522C1290.54 198.522 1291.45 198.729 1291.45 200V200.207C1291.45 201.558 1290.21 201.669 1288.44 201.669H1285.26V198.522H1288.54ZM1288.46 203.942C1290.61 203.942 1291.29 204.435 1291.29 206.135V206.835C1291.29 207.137 1291.32 207.486 1291.61 207.598H1294.39C1294.15 207.455 1294.12 207.137 1294.12 206.867V206.12C1294.12 204.117 1293.37 203.211 1291.72 202.845C1293.4 202.432 1294.2 201.542 1294.2 199.841C1294.2 197.362 1292.56 196.265 1288.57 196.265H1282.61V207.598H1285.26V203.942H1288.46ZM1307.4 205.277H1298.8V203.036H1305.79V200.795H1298.8V198.506H1307.06V196.265H1296.24V207.598H1307.4V205.277Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.58 118.137H1205.35C1208.44 118.137 1210.11 117.004 1210.11 114.287V114.232C1210.11 111.482 1208.45 110.294 1205.24 110.294H1201.58V118.137ZM1205.16 111.889C1207.39 111.889 1208.23 112.527 1208.23 114.221V114.254C1208.23 115.937 1207.42 116.531 1205.25 116.531H1203.41V111.889H1205.16ZM1215.97 118.357C1218.72 118.357 1220.67 117.037 1220.67 114.309V114.232C1220.67 111.57 1218.67 110.096 1215.96 110.096C1213.25 110.096 1211.29 111.614 1211.29 114.243V114.298C1211.29 117.114 1213.16 118.357 1215.97 118.357ZM1215.96 116.685C1214.22 116.685 1213.19 115.926 1213.19 114.287V114.276C1213.19 112.494 1214.22 111.757 1215.97 111.757C1217.7 111.757 1218.77 112.439 1218.77 114.287V114.298C1218.77 116.069 1217.7 116.685 1215.96 116.685ZM1223.91 112.758L1228.72 118.137H1230.49V110.294H1228.72V115.717L1228.66 115.618L1223.89 110.294H1222.05V118.137H1223.83V112.648L1223.91 112.758ZM1237.79 114.936H1234.9L1236.32 111.955L1237.79 114.936ZM1239.37 118.137H1241.34L1237.3 110.294H1235.35L1231.38 118.137H1233.37L1234.19 116.432H1238.53L1239.37 118.137ZM1247.59 111.867V110.294H1239.93V111.867H1242.75V118.137H1244.64V111.867H1247.59ZM1254.66 118.137V116.421H1252.53V111.933H1254.66V110.294H1248.65V111.933H1250.78V116.421H1248.65V118.137H1254.66ZM1260.09 118.357C1262.84 118.357 1264.79 117.037 1264.79 114.309V114.232C1264.79 111.57 1262.78 110.096 1260.08 110.096C1257.37 110.096 1255.4 111.614 1255.4 114.243V114.298C1255.4 117.114 1257.27 118.357 1260.09 118.357ZM1260.08 116.685C1258.34 116.685 1257.31 115.926 1257.31 114.287V114.276C1257.31 112.494 1258.34 111.757 1260.09 111.757C1261.82 111.757 1262.88 112.439 1262.88 114.287V114.298C1262.88 116.069 1261.82 116.685 1260.08 116.685ZM1268.02 112.758L1272.84 118.137H1274.61V110.294H1272.84V115.717L1272.78 115.618L1268.01 110.294H1266.17V118.137H1267.95V112.648L1268.02 112.758ZM1280.36 118.368C1283.1 118.368 1284.36 117.378 1284.36 115.706C1284.36 114.111 1283.17 113.517 1280.34 113.385C1278.13 113.286 1277.83 113.077 1277.83 112.527C1277.83 111.977 1278.31 111.636 1279.78 111.636C1281.25 111.636 1282.17 111.845 1282.39 112.835H1284.36C1283.98 110.877 1282.52 110.096 1279.81 110.096C1277.26 110.096 1275.96 111.075 1275.96 112.582C1275.96 114.232 1277.09 114.782 1279.48 114.925C1281.87 115.057 1282.5 115.09 1282.5 115.838C1282.5 116.487 1281.85 116.762 1280.41 116.762C1278.83 116.762 1277.86 116.443 1277.59 115.354H1275.59C1276 117.444 1277.27 118.368 1280.36 118.368Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.48 293.785C1083.48 293.339 1083.35 292.977 1083.08 292.7C1082.81 292.413 1082.48 292.163 1082.08 291.951C1081.68 291.727 1081.25 291.52 1080.78 291.328C1080.32 291.137 1079.88 290.908 1079.47 290.642C1079.08 290.366 1078.75 290.031 1078.49 289.637C1078.22 289.233 1078.09 288.722 1078.09 288.105C1078.09 287.233 1078.39 286.542 1079 286.031C1079.6 285.521 1080.46 285.265 1081.58 285.265C1082.23 285.265 1082.82 285.313 1083.35 285.409C1083.88 285.505 1084.3 285.627 1084.6 285.776L1084.2 286.941C1083.95 286.824 1083.59 286.712 1083.11 286.606C1082.64 286.499 1082.11 286.446 1081.52 286.446C1080.82 286.446 1080.29 286.606 1079.94 286.925C1079.59 287.233 1079.41 287.6 1079.41 288.026C1079.41 288.44 1079.54 288.786 1079.81 289.063C1080.08 289.339 1080.41 289.589 1080.8 289.813C1081.2 290.025 1081.64 290.238 1082.11 290.451C1082.58 290.663 1083.01 290.913 1083.4 291.201C1083.8 291.477 1084.14 291.812 1084.4 292.206C1084.67 292.599 1084.8 293.089 1084.8 293.674C1084.8 294.152 1084.72 294.583 1084.55 294.966C1084.38 295.349 1084.13 295.679 1083.8 295.955C1083.47 296.232 1083.07 296.445 1082.6 296.594C1082.13 296.742 1081.6 296.817 1081.01 296.817C1080.21 296.817 1079.55 296.753 1079.03 296.625C1078.51 296.508 1078.1 296.375 1077.82 296.227L1078.26 295.03C1078.51 295.168 1078.87 295.306 1079.35 295.445C1079.83 295.572 1080.36 295.636 1080.96 295.636C1081.31 295.636 1081.64 295.604 1081.95 295.54C1082.26 295.466 1082.52 295.354 1082.75 295.205C1082.97 295.046 1083.14 294.849 1083.27 294.615C1083.41 294.381 1083.48 294.104 1083.48 293.785Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.99 291.456H1088.24V296.625H1086.91V285.457H1088.24V290.658L1088.96 290.435L1092.71 285.457H1094.24L1090.5 290.259L1089.83 290.786L1090.65 291.424L1094.73 296.625H1093.06L1088.99 291.456Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.96 285.457H1098.28V296.625H1096.96V285.457Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.31 289.318L1102.44 287.706H1102.38L1102.54 289.318V296.625H1101.3V285.281H1102L1107.34 292.732L1108.17 294.264H1108.25L1108.08 292.732V285.457H1109.32V296.801H1108.62L1103.31 289.318Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.15 288.057C1119.15 288.334 1119.11 288.611 1119.04 288.887C1118.97 289.164 1118.86 289.419 1118.7 289.653C1118.54 289.876 1118.33 290.078 1118.08 290.259C1117.82 290.429 1117.51 290.557 1117.15 290.642V290.738C1117.47 290.791 1117.77 290.882 1118.06 291.009C1118.35 291.137 1118.6 291.312 1118.81 291.536C1119.02 291.759 1119.19 292.03 1119.31 292.349C1119.43 292.669 1119.5 293.046 1119.5 293.482C1119.5 294.057 1119.38 294.557 1119.13 294.982C1118.89 295.397 1118.56 295.737 1118.14 296.003C1117.74 296.269 1117.27 296.466 1116.75 296.594C1116.23 296.721 1115.7 296.785 1115.14 296.785C1114.96 296.785 1114.73 296.785 1114.44 296.785C1114.16 296.785 1113.86 296.774 1113.53 296.753C1113.21 296.742 1112.88 296.721 1112.54 296.689C1112.21 296.657 1111.91 296.609 1111.63 296.546V285.537C1111.83 285.505 1112.06 285.473 1112.32 285.441C1112.58 285.409 1112.87 285.382 1113.16 285.361C1113.46 285.34 1113.76 285.324 1114.07 285.313C1114.39 285.303 1114.71 285.297 1115.01 285.297C1115.54 285.297 1116.04 285.34 1116.53 285.425C1117.03 285.499 1117.47 285.638 1117.85 285.84C1118.25 286.042 1118.56 286.324 1118.8 286.685C1119.03 287.047 1119.15 287.504 1119.15 288.057ZM1115.16 294.982C1115.42 294.982 1115.68 294.95 1115.92 294.886C1116.18 294.822 1116.4 294.727 1116.59 294.599C1116.79 294.461 1116.94 294.291 1117.06 294.089C1117.17 293.886 1117.23 293.647 1117.23 293.371C1117.23 293.02 1117.16 292.743 1117.02 292.541C1116.89 292.339 1116.71 292.185 1116.48 292.078C1116.26 291.961 1116.01 291.887 1115.73 291.855C1115.46 291.823 1115.18 291.807 1114.9 291.807H1113.74V294.886C1113.79 294.908 1113.88 294.924 1113.99 294.934C1114.11 294.945 1114.23 294.955 1114.36 294.966C1114.5 294.966 1114.64 294.971 1114.78 294.982C1114.92 294.982 1115.05 294.982 1115.16 294.982ZM1114.44 290.148C1114.59 290.148 1114.76 290.142 1114.95 290.132C1115.15 290.121 1115.32 290.105 1115.45 290.084C1115.85 289.956 1116.2 289.765 1116.48 289.509C1116.78 289.254 1116.93 288.919 1116.93 288.504C1116.93 288.228 1116.88 287.999 1116.77 287.818C1116.66 287.637 1116.52 287.494 1116.34 287.387C1116.17 287.281 1115.97 287.207 1115.75 287.164C1115.53 287.121 1115.29 287.1 1115.05 287.1C1114.77 287.1 1114.51 287.105 1114.28 287.116C1114.05 287.127 1113.87 287.143 1113.74 287.164V290.148H1114.44Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.56 294.152H1123.13L1122.29 296.625H1120.1L1124.12 285.377H1125.73L1129.75 296.625H1127.46L1126.56 294.152ZM1123.69 292.397H1126.08L1125.25 289.908L1124.92 288.153H1124.84L1124.5 289.924L1123.69 292.397Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.72 285.568C1130.96 285.526 1131.22 285.489 1131.5 285.457C1131.79 285.414 1132.07 285.382 1132.35 285.361C1132.63 285.34 1132.91 285.324 1133.18 285.313C1133.44 285.303 1133.69 285.297 1133.91 285.297C1134.43 285.297 1134.94 285.345 1135.44 285.441C1135.95 285.537 1136.4 285.701 1136.8 285.935C1137.2 286.169 1137.52 286.494 1137.76 286.909C1138 287.313 1138.12 287.823 1138.12 288.44C1138.12 289.355 1137.91 290.1 1137.48 290.674C1137.06 291.249 1136.49 291.647 1135.78 291.871L1136.56 292.365L1139.11 296.625H1136.59L1134.05 292.254L1132.9 292.046V296.625H1130.72V285.568ZM1134.07 287.244C1133.85 287.244 1133.62 287.249 1133.4 287.26C1133.19 287.27 1133.02 287.292 1132.9 287.324V290.562H1133.83C1134.44 290.562 1134.92 290.424 1135.28 290.148C1135.64 289.871 1135.82 289.414 1135.82 288.775C1135.82 288.297 1135.68 287.925 1135.38 287.659C1135.08 287.382 1134.64 287.244 1134.07 287.244Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.44 291.041C1139.44 289.18 1139.85 287.749 1140.66 286.749C1141.48 285.739 1142.65 285.233 1144.18 285.233C1144.97 285.233 1145.67 285.372 1146.27 285.648C1146.86 285.925 1147.36 286.318 1147.75 286.829C1148.14 287.339 1148.44 287.951 1148.63 288.664C1148.82 289.376 1148.91 290.169 1148.91 291.041C1148.91 292.903 1148.5 294.339 1147.67 295.349C1146.85 296.349 1145.69 296.849 1144.18 296.849C1143.37 296.849 1142.66 296.711 1142.07 296.434C1141.47 296.157 1140.98 295.764 1140.59 295.253C1140.2 294.743 1139.91 294.131 1139.72 293.418C1139.53 292.706 1139.44 291.913 1139.44 291.041ZM1141.73 291.041C1141.73 291.605 1141.78 292.126 1141.88 292.605C1141.97 293.073 1142.12 293.477 1142.31 293.817C1142.51 294.158 1142.77 294.424 1143.07 294.615C1143.38 294.807 1143.75 294.902 1144.18 294.902C1144.95 294.902 1145.55 294.599 1145.98 293.993C1146.4 293.387 1146.62 292.403 1146.62 291.041C1146.62 290.499 1146.57 289.993 1146.47 289.525C1146.39 289.057 1146.25 288.648 1146.06 288.297C1145.87 287.946 1145.62 287.675 1145.31 287.483C1145 287.281 1144.62 287.18 1144.18 287.18C1143.4 287.18 1142.8 287.494 1142.37 288.121C1141.95 288.738 1141.73 289.711 1141.73 291.041Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.25 290.802L1152.37 289.047H1152.29L1152.55 290.802V296.625H1150.48V285.377H1152.07L1156.3 291.328L1157.15 293.035H1157.23L1156.97 291.328V285.457H1159.04V296.705H1157.45L1153.25 290.802Z",
    fill: "#18162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8905 187.396C58.5609 187.396 59.1043 186.852 59.1043 186.182C59.1043 185.512 58.5609 184.968 57.8905 184.968C57.2202 184.968 56.6768 185.512 56.6768 186.182C56.6768 186.852 57.2202 187.396 57.8905 187.396Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.33 187.396C62.0003 187.396 62.5437 186.852 62.5437 186.182C62.5437 185.512 62.0003 184.968 61.33 184.968C60.6596 184.968 60.1162 185.512 60.1162 186.182C60.1162 186.852 60.6596 187.396 61.33 187.396Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7001 187.396C65.3704 187.396 65.9138 186.852 65.9138 186.182C65.9138 185.512 65.3704 184.968 64.7001 184.968C64.0297 184.968 63.4863 185.512 63.4863 186.182C63.4863 186.852 64.0297 187.396 64.7001 187.396Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.776 180.854H54.3173C53.2384 180.854 52.3618 181.731 52.3618 182.81V197.173L51.2829 195.892C51.0132 195.554 50.5412 195.42 50.1366 195.554L33.4137 201.016C33.0765 201.151 32.8068 201.421 32.6719 201.758C32.6045 202.095 32.6719 202.5 32.8742 202.77L38.5384 209.378L32.8742 215.986C32.6045 216.256 32.5371 216.66 32.6719 216.998C32.7394 217.335 33.0091 217.604 33.4137 217.739L38.943 219.56V231.293C38.943 231.765 39.2802 232.17 39.6848 232.304L56.3403 237.766C56.4751 237.834 56.5425 237.834 56.6774 237.834C56.8123 237.834 56.8797 237.834 57.0146 237.766L73.7375 232.237C74.2095 232.102 74.4792 231.698 74.4792 231.226V219.493L79.8737 217.739H94.776C95.8549 217.739 96.7315 216.863 96.7315 215.784V182.81C96.7315 181.731 95.8549 180.854 94.776 180.854ZM94.5737 183.012V189.351H54.5196V183.012H94.5737ZM35.6389 202.567L50.0692 197.847L54.7893 203.376L40.3591 208.097L35.6389 202.567ZM35.6389 216.121L40.3591 210.592L54.7893 215.312L50.0692 220.841L35.6389 216.121ZM55.5985 235.137L41.1008 230.416V220.234L50.0017 223.134C50.1366 223.201 50.204 223.201 50.3389 223.201C50.676 223.201 50.9458 223.066 51.1481 222.797L55.5311 217.739V235.137H55.5985ZM56.6774 213.626L43.5958 209.31L56.7448 204.995L69.8265 209.31L56.6774 213.626ZM58.6329 203.376L63.3531 197.847L77.7834 202.567L73.0632 208.097L58.6329 203.376ZM72.254 230.416L57.7563 235.137V217.739L62.1393 222.797C62.3416 223.066 62.6788 223.201 62.9485 223.201C63.0834 223.201 63.1508 223.201 63.2857 223.134L72.1866 220.234V230.416H72.254ZM63.3531 220.841L58.6329 215.312L73.0632 210.592L77.7834 216.121L63.3531 220.841ZM80.1434 215.514L74.8164 209.31L80.4806 202.702C80.7503 202.432 80.8177 202.028 80.6829 201.691C80.6155 201.354 80.3457 201.084 79.9411 200.949L63.3531 195.554C62.9485 195.42 62.4765 195.554 62.2068 195.892L56.7448 202.23L54.587 199.735V191.643H94.5737V215.582H80.1434V215.514Z",
    fill: "#0A2133"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.845 18.0737L190.815 202.797",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.811 202.797L504.841 387.521",
    stroke: "#1F4F22",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 146.217,
    y: 200.796,
    width: 46.599,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.65098 0 0 0 0 0.14902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd",
    x: 1011.55,
    y: 107.562,
    width: 178.996,
    height: 198.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.945098 0 0 0 0 0.756863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd",
    x: -6.33105,
    y: 102.562,
    width: 188.996,
    height: 208.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.698039 0 0 0 0 0.835294 0 0 0 0 0.188235 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd",
    x: 1162.18,
    y: 18.5605,
    width: 178.996,
    height: 198.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.945098 0 0 0 0 0.756863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bd",
    x: 1162.18,
    y: 194.565,
    width: 178.996,
    height: 198.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.945098 0 0 0 0 0.756863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bd",
    x: 868.465,
    y: 107.563,
    width: 178.996,
    height: 198.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.945098 0 0 0 0 0.756863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bd",
    x: 1019.1,
    y: 18.5601,
    width: 178.996,
    height: 198.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.945098 0 0 0 0 0.756863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bd",
    x: 1019.1,
    y: 194.565,
    width: 178.996,
    height: 198.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.945098 0 0 0 0 0.756863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_bd",
    x: 1169.73,
    y: 107.563,
    width: 178.996,
    height: 198.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.945098 0 0 0 0 0.756863 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bd",
    x: 514.155,
    y: 84.8447,
    width: 220.019,
    height: 244.774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.65098 0 0 0 0 0.14902 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i",
    x: 502.27,
    y: 15.3359,
    width: 319.508,
    height: 378.923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.65098 0 0 0 0 0.14902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i",
    x: 817.036,
    y: 200.796,
    width: 49.6803,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.65098 0 0 0 0 0.14902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i",
    x: 859.604,
    y: 8.49854,
    width: 331.132,
    height: 392.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.65098 0 0 0 0 0.14902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i",
    x: 188.073,
    y: 15.3359,
    width: 319.509,
    height: 378.923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.65098 0 0 0 0 0.14902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1165.54,
    y1: 237.359,
    x2: 1090.33,
    y2: 132.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1C1",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#DBF1C1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 152.665,
    y1: 237.359,
    x2: 77.4509,
    y2: 132.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D530",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#B2D530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1316.18,
    y1: 148.357,
    x2: 1240.96,
    y2: 43.5694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1C1",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#DBF1C1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1316.18,
    y1: 324.361,
    x2: 1240.96,
    y2: 219.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1C1",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#DBF1C1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 893.465,
    y1: 166.719,
    x2: 968.679,
    y2: 271.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1C1",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#DBF1C1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1044.1,
    y1: 77.7157,
    x2: 1119.31,
    y2: 182.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1C1",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#DBF1C1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1044.1,
    y1: 253.721,
    x2: 1119.31,
    y2: 358.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1C1",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#DBF1C1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1194.73,
    y1: 166.719,
    x2: 1269.95,
    y2: 271.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1C1",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#DBF1C1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 662.109,
    y1: 109.845,
    x2: 549.536,
    y2: 190.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53A626",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#53A626"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1344,
    height: 420,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningOverview);
export default __webpack_public_path__ + "static/media/earning-overview.8eb515c3416e0f9c51a4dedf0f6d6ff0.svg";
export { ForwardRef as ReactComponent };